import React, { Component, Fragment } from 'react';
import { Table,Image } from "semantic-ui-react";
import {Button, Icon, Message, Modal, Form,Checkbox,Dropdown,TextArea} from "semantic-ui-react"
import { Link } from "react-router-dom"
import shop from "shop/shop"
 //ELEM REACT16 CHANGE
import _ from "lodash"
import productStore from "stores/productStore"
import ordinals from "theme/arnoldsports/sortParamsVariant"
import moment                               from "moment"
import Spinner                              from "components/Spinner/Spinner"
import SuccessTable                         from "components/Product/SuccessTableReturn"
import Responsive from "react-responsive"
import ContactMessage from 'components/Messages/ContactMessage';
import LocalFooter from 'components/LocalFooter';
import ReturnPageProgress from './ReturnPageProgress';
import BarcodeScanner from 'components/BarcodeScanner/BarcodeScannerJS';

class ReturnPage extends Component {
    state = {
        inventory: false,
        inventoryOrder: [],
        byId: {},
        loading: false,
        showContact: false,
        loadingDelivery: false,
        notFoundPositions: [],
        allProducts: [],
        buttonDisabled: false,
        seasonActive: false,
        newSeason: {
            season: {
                referenceNumber: "",
                email: "",
                start: "",
                end: "",
                name: ""
            }
        }
    };

    componentDidMount() {
        if(!shop.session){
            console.log("!shop.session")
            this.props.history.push("/login")
          }
        this.handleLoadInventory();
        //this.setState({loading: true})
        this.handleFetchDate();
        this.setState({buttonDisabled: true})
        this.handleLoadDelivery();
    }

    handleLoadInventory = async () => {
        try{
            //shop/rest/data/inventories?start=0&count=50
            const response = await shop.fetch( `/shop/rest/data/inventories?start=0&count=50`, {
                method: "GET",
                credentials:"include",
            });
            console.log(response);
            if(response.size >= 1){
                this.setState({inventory: true})
                this.setState({inventoryOrder: response.values[0]})
                console.log("RETOURE BEREITS GETÄTIGT", this.state.inventoryOrder)
            }
            this.setState({loading: false})
        }
        catch (error) {
            console.error(error);
        }
    }

    handleFetchDate  = async () => {
        console.log("DATA handleFetchDate")
        try {
          const response = shop.fetch('/shop/rest/config/?set=' + encodeURIComponent(JSON.stringify(["web.kv.saison","web.kv.start","web.kv.end"])), {
            method: 'GET',
            credentials: 'include'
          });
          //console.log("DATA: ", response, this.state.newSeason);

          response.then(data => {
            //console.log("DATA RETURN: ", data["web.kv.end"]);
            this.setState({
              newSeason: {
                season: {
            start: data["web.kv.start"],
            end: data["web.kv.end"],
            name: decodeURIComponent(data["web.kv.saison"])
                }
              }
            });
            this.setState({})
            //console.log("DATA POST: ", data);
            const today = new Date();
            const startDate = moment(data["web.kv.start"], "DD.MM.YYYY").toDate();
            const endDate = moment(data["web.kv.end"], "DD.MM.YYYY").toDate();
            //console.log("DATA DATE: ", today, startDate, endDate);
            if (today >= startDate && today <= endDate) {
              this.setState({ seasonActive: true });
              //console.log("DATA ACTIVE: ", this.state.newSeason);
            }
          })

        } catch (error) {
          console.error('Error fetching date:', error);
        }
      }


    handleLoadDelivery = async () => {
            
            try {
                const response = await shop.fetch( `/shop/rest/data/delivery?start=0&count=1000`, {
                    method: "GET",
                    credentials:"include",
                });
                //console.log("RESP: RETURN",response);
                if(!shop.delivery){
                    shop.delivery = {};
                }
                shop.delivery = response;
                if(!shop.delivery[0]){
                    shop.delivery[0] = {};
                }
                if(!shop.delivery[0].products){
                    shop.delivery[0].products = [];
                }
                shop.delivery[0].sum = 0;
                shop.delivery[0].contact = {
                    email: "",
                    email1:"",
                    email2:"",
                    phone: "",
                    phone1: "",
                    mobile: "",
                    contact: "",
                    comment: ""
                }
            }
            catch (error) {
                console.error(error);
            }
            try{
                const response2 = await shop.fetch( `/shop/rest/data/v2/search?value=&filter=%5B%5D&start=0&count=192&sort=des&dir=desc&artnr=0&mainonly=0&variants=0&lang=de`, {
                    method: "GET",
                    credentials:"include",
                });
                //console.log("RESP: ", response2,response2.result[0], response2.result[0].map_id);
                this.setState({allProducts: response2.result})
                //console.log("RESP: ", this.state.allProducts)
            }
            catch (error) {
                console.error(error);
            }
            if(shop.delivery && shop.delivery[0]){
                shop.delivery[0].positions = this.state.allProducts
                shop.delivery[0].products = this.state.allProducts
            }
            else{
                shop.delivery[0] = {}
                shop.delivery[0].positions = this.state.allProducts
                shop.delivery[0].products = this.state.allProducts
            }
            //shop.delivery[0].positions.sort((a, b) => a.product.sort - b.product.sort);
            for (let i = 0; i < shop.delivery[0].positions.length; i++) {
                //await shop.fetch(`/shop/rest/data/products/${shop.delivery[0].positions[i].article_id}?lang=de`)
                try{
                    /*shop.delivery[0].positions[i].product = await shop.fetch( `/shop/rest/data/products/${shop.delivery[0].positions[i].map_id}?lang=de`
                    , {
                        method: "GET",
                        credentials:"include",
                    });*/
                    shop.delivery[0].positions[i].product = shop.delivery[0].positions[i]
                    shop.delivery[0].positions[i].product.deliveryCount = 0
                    shop.delivery[0].positions[i].product.trueReturnValue = false
                    shop.delivery[0].positions[i].product.count = shop.delivery[0].positions[i].count
                    
                }
                catch (error) {
                    console.error(error);
                }
            }
            this.setState({ buttonDisabled: false });
            for (let i = shop.delivery[0].positions.length - 1; i >= 0; i--) {
                if (!shop.delivery[0].positions[i].product) {
                    this.setState(prevState => ({
                        notFoundPositions: [...prevState.notFoundPositions, shop.delivery[0].positions[i]],
                    }));
                    shop.delivery[0].positions.splice(i, 1);
                }
            }
            shop.delivery[0].positions.sort((a, b) => a.product.sort - b.product.sort);
            for(let i = 0; i < shop.delivery[0].positions.length; i++){
                if(!shop.delivery[0].positions[i].count){
                    shop.delivery[0].positions[i].count = 0
                }
                if(shop.delivery[0].positions[i] ){
                    //console.log("ADD: ",shop.delivery[0].positions[i].map_id, shop.delivery[0].positions[i].count)
                    //this.loadProduct( shop.delivery[0].positions[i].map_id, 0,false )
                }
            }
                
    }

    loadProduct( id,deliveryCount ) {
		if ( this.id === id ) return
		this.id = id
		productStore.get( id )
			.then( product => {
                //console.log("RESP: product RETURN",product)
                if(!product){
                    return false
                }
				product.count = 1
                
				let inCart = shop.cart.productsById.get( product.map_id )
                product.deliveryCount = deliveryCount
                product.extras.deliveryCount = deliveryCount
                product.extras.trueReturnValue = product.extras.trueReturnValue || false
                //shop.cart.setExtraPositions(product, "rewe_nan1", product.extras.rewe_nan && product.extras.rewe_nan.value ? product.extras.rewe_nan.value.value : "");
                shop.cart.add( product )
				if ( inCart ) product.count = Number( inCart.count )
				shop.analytics.push( product.map_id )
				// lastProducts = shop.analytics.lastProducts( 4 )
				//   .filter( ( id ) => id !== product.map_id )
				this.setState( {product: product, primaryImage: false} )

				if ( !product.mainart ) return
				productStore.partlist( product.mainart , true )
					.then( variants => {
						if ( !variants ) {
							console.error( "ProductPage: Keine Varianten gefunden ", {product} )
							return
						}
						const variantProtoypeByKey = {}

						let byAttribute = {}
						let variantMap = {}
						variants.variants.varfields.forEach( varfield => {

							let categories = _.groupBy( variants.products, `extraValue.${varfield}` )
							var ordered = {};
							// TODO: UNIFY
							_( categories ).keys().sort(
								( a, b ) => {
									let s0 = ordinals[a]
									let s1 = ordinals[b]
									return s0 >= s1 ? 1 : -1
								}
							).each( function ( key ) {
								ordered[key] = categories[key];
							} );
							byAttribute[varfield] = ordered
						} )

						let count = 0
						variants.products.forEach( product => {
							if ( !product.available ) return
							count++
							const hash = variants.variants.varfields
								.map( varfield => {
									const bucket = variantProtoypeByKey[varfield] || {}
									if ( !bucket[product.extraValue[varfield]] ) {
										bucket[product.extraValue[varfield]] = product
									}
									variantProtoypeByKey[varfield] = bucket

									return product.extraValue[varfield] || "null"
								} )
								.join( "___" )

							variantMap[hash] = product
						} )

						//console.log( "variantProtoypeByKey", variantProtoypeByKey, {variantMap, count, count_all: variants.products.length} )
						this.setState( {variants, byAttribute, variantMap, variantProtoypeByKey} )
					} )
			} )
			.catch( error => {
				this.setState( {error} )
			} )
	}

    render() {
        const { buttonDisabled, seasonActive } = this.state
        if(this.state.loading){
            return (
                <div className="pa4 tc">
                    <Spinner size="md" type="inverted"/>
                </div>
            )
        }

        if(!shop.session){
            console.log("!shop.session")
            this.props.history.push("/login")
            document.location.reload()
            return null
        }
        let { product, categoryId = "" } = this.props

        //Only Single Return
        if(this.state.inventory){
            let order = this.state.inventoryOrder
            let byId = {}
            console.log("INVENTORY", this.state.inventory,"INVENTORY ORDER",this.state.inventoryOrder)
            
            return (
                <Fragment>
                    <section className="container pt2">
                        <ReturnPageProgress progress={4} />
                    </section>
                    <Responsive minWidth={790} >
                    <section className="container tc pb2 pt2">
                <a className={"logo"} >
									<img
										src={shop.config.logo}
										alt="" />
								</a>
					</section>
                <section className="container pb4" style={{width:"45%"}}>
                <Message>
						<ContactMessage />
						</Message>
                    <div>
                    <Message className="f2 fw7">
                    {translate( "Ihre Restantenerfassung ist bei uns eingegangen und wird schnellstmöglich bearbeitet.")}
                            </Message>
					<Table className="pl4 pr4">
					<colgroup>
					</colgroup>
					<thead>
					</thead>
					<tbody>
                        <tr>
                        <h1 style={{color:"#917236"}}  className="pt4 tl"><b>{translate("Restantenerfassung Online ")}</b></h1><br/>

                            <p className="pb2">Sie sind angemeldet als: </p>
                        </tr>
                        <tr>
                            <td>
                                <Table className="TableCustData">
                                    <colgroup>
                                        <col width="50%" />
                                        <col width="25%" />
                                    </colgroup>
                                    <thead>
                                        <tr>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td style={{fontSize:15}}><b>Kundennummer:</b>
                                            </td> 
                                            <td>{shop.session.value.map_id}
                                            </td> 
                                        </tr>
                                        <tr>
                                            <td style={{fontSize:15, alignContent:"top"}}><b >Filiale:</b><br/><br/><br/>
                                            </td> 
                                            <td><strong>{shop.session.value.title}</strong><br/>
                                                {shop.session.value.street}<br/>
                                                {shop.session.value.pcode + " " + shop.session.value.city}<br/>
                                                {shop.session.value.country}
                                            </td> 
                                        </tr>
                                        <tr>
                                        </tr>
                                    </tbody>
                                </Table>
                                </td>
                        </tr>
                        <tr>
                            <br/>
                        </tr>
                        <tr>
                            <td>
                            <Link to={{
                                pathname: `/logout`,
                                search  : this.props.location.search
                            }}>
                                <Button
                                >
                                {translate( "Zurück zur Anmeldung" )}
                                <i className="icon-angle-right"/>
                                </Button>
                            </Link>
                            </td>
                            <td>
                                <Button onClick={()=> (
                                    this.setState({ showContact: !this.state.showContact })
                                    )}>Kontakt</Button>
                            </td>
                        </tr>
                    </tbody>
                    </Table>
                    </div>
                </section>


                        {/*<div className="ui container mw9 ph3 center pt4">
                            <section className="billing-tab">
                                <img alt={"Firmenlogo"} width={235} className="pt2 pb4" src={shop.config.logo}/>
                                
                                <h1 className="tl ttu b pb2">{translate( "Vorläufige Restantenbestätigung" )} </h1>

                                <p>Ihre Restanten ist bei uns eingegangen und wird schnellstmöglich bearbeitet.</p>
                            </section>
                            
                            <section className="billing-tab pt4">
                                <h4>{translate( "your data" )}</h4>
                                <table className="" style={{width:"50%"}}>
                                
                                <colgroup>
                                    <col width="25%"/>
                                    <col width="75%"/>
                                </colgroup>
                                
                                <tbody>
                                {shop.config.checkoutFeatures.orderNumber && <tr>
                                    <td>{translate( "Order Id" )}</td>
                                    <td className="overview-value">{order.handid}</td>
                                </tr>
                                }
                                            
                                {order.extras.manual_order_id &&
                                    <tr>
                                    <td>{translate( "manual_order_id" )}</td>
                                    <td className="overview-value">{order.extras.referenceId}</td>
                                    </tr>
                                }
                                {order.extras.referenceId &&
                                    <tr>
                                    <td>{translate( "Referenznummer" )}</td>
                                    <td className="overview-value">{order.extras.manual_order_id}</td>
                                    </tr>
                                }
                                
                                {shop.config.checkoutFeatures.orderDate &&
                                    <tr>
                                    <td>{translate( "Bestellzeitpunkt" )}</td>
                                    <td className="overview-value">{moment( order.created ).format( "HH:mm [Uhr], DD.MMM YYYY" )}</td>
                                    </tr>
                                }
                                
                                
                                <tr className="bb b--black-10">
                                    <td className="bb b--black-10">{translate( "Kundennummer:" )}</td>
                                    <td className="overview-value">{order.customerid}</td>
                                </tr>
                                <tr className="bb b--black-10">
                                    <td className="bb b--black-10">{translate( "Ansprechpartner:" )}</td>
                                    <td className="overview-value">{order.extras.contact || "-"}</td>
                                </tr>
                                <tr className="bb b--black-10">
                                    <td className="bb b--black-10">{translate( "E-Mail:" )}</td>
                                    <td className="overview-value">{order.extras.email || order.customer.email || "-"}</td>
                                </tr>
                                
                                <tr className="bb b--black-10">
                                    <td >{translate( "Telefon:" )}</td>
                                    <td className="overview-value">{order.extras.phone || order.customer.email ||  "-"}</td>
                                </tr>
                                
                                </tbody>
                                </table>
                            </section>
                            
                            <section className="billing-tab pt4">
                                <tr>
                                <td sm="1/2">
                                    <h4>{translate( "Marktadresse" )}</h4>
                                    <p>
                                    {order.bill.name1} {order.bill.name2} {order.bill.name3} <br/>
                                    {order.bill.street} <br/>
                                    {order.bill.pcode} {order.bill.city} <br/>
                                    {order.bill.country}
                                    </p>
                                </td>
                                </tr>
                            </section>
                            
                            <section className="billing-tab pt4">
                                <h2>{<span>{translate( "Ihre Restanten" )}</span>}</h2>
                                <SuccessTable showTax={order.extras.payment} positions={order.positions} byId={byId} netto={order.netto} currency={order.currency}/>
                                
                                
                                {order.customer.extras.zahlung && <div>
                                <h3 className="mt4">{translate( "Zahlungsweise" )}</h3>
                                <p>{order.customer.extras.zahlung}</p>
                                </div>}
                                
                                {order.deliverdate && <div>
                                <h3 className="mt4">{translate( "Liefertermin (Wunsch)" )}</h3>
                                <p>{moment( moment( order.deliverdate ), "DD.MM.YYYY" ).format( "dddd, DD. MMMM YYYY" )}</p>
                                </div>}
                                
                                
                                {order.extras.attachments && <div>
                                <h3 className="mt4">Ihr Anhang</h3>
                                <p>{order.extras.attachments}</p>
                                </div>}
                                
                                {order.extras.print_receipt && <div>
                                <h3 className="mt4">{translate( "Belegausdruck/Innendienst" )}</h3>
                                <p>{order.extras.print_receipt}</p>
                                </div>}
                                
                            </section>
                            
                            {shop.config.checkout_thank_you && <div className="pv4">
                                <div style={{ whiteSpace: "pre-line" }}>{window.translate( "checkout_thank_you" )}</div>
                            </div>}
                            <div className="tl pb3 pt3">
                            <Link to={{
                                pathname: `/logout`,
                                search  : this.props.location.search
                            }}>
                                <Button
                                >
                                {translate( "Zurück zur Anmeldung" )}
                                <i className="icon-angle-right"/>
                                </Button>
                            </Link>
                            </div>
                        </div>*/}
                    </Responsive>
                    <Responsive maxWidth={789}>
                    <section className="container tc pb2 pt2">
                <a className={"logo"} >
									<img
										src={shop.config.logo}
										alt="" />
								</a>
					</section>
                <div className="pa3">
                <Message className="f2 fw7">
                    {translate( "Ihre Restantenerfassung ist bei uns eingegangen und wird schnellstmöglich bearbeitet.")}
                            </Message>
                    <table className="pl3 pr3" >
                        <colgroup>
                        <col width="100%" />
                        </colgroup>
                        <tbody>
                            <tr className="tc bb b--black-20 bt">
                                <td>
                                    <h1 style={{color:"#917236"}}  className="pt4 tc"><b>{translate("Restantenerfassung Online ")}</b></h1><br/>
                                    
                                    <p className="tc pb2">Sie sind angemeldet als: </p>

                                </td>
                            </tr>
                            <tr className="pa2 bb b--black-20">
                                
                                <td>
                                    <table>
                                    <colgroup>
                                        <col width="25%" />
                                        <col width="75%" />
                                    </colgroup>
                                    <tbody>
                                        <tr className="bb b--black-10">
                                            <td style={{fontSize:15}}><b>Kundennummer:</b>
                                            </td> 
                                            <td>{shop.session.value.map_id}
                                            </td> 
                                        </tr>
                                        <tr>
                                            <td style={{fontSize:15, alignContent:"top"}}><b >Filiale:</b><br/><br/><br/>
                                            </td> 
                                            <td><strong>{shop.session.value.title}</strong><br/>
                                                {shop.session.value.street}<br/>
                                                {shop.session.value.pcode + " " + shop.session.value.city}<br/>
                                                {shop.session.value.country}
                                            </td> 
                                        </tr>
                                        <tr>
                                        </tr>
                                    </tbody>
                                    </table>
                                    
                                </td>
                                <td>&nbsp;</td>
                            </tr>
                            <tr>
                            <td>
                                <div className="pb2 tc">
                                </div>
                            </td>
                        </tr>
                        </tbody>

                    </table>
                    <table>
                        <colgroup>
                            <col width="50%" />
                            <col width="50%" />
                        </colgroup>
                        <tbody>
                            <tr className="tc">
                                <td className="tc">
                                    <Link to={{
                                        pathname: `/logout`,
                                        search  : this.props.location.search
                                    }}>
                                        <Button style={{maxWidth:"150px", minWidth:"150px"}}
                                        >
                                        {translate( "Zurück zur Anmeldung" )}
                                        <i className="icon-angle-right"/>
                                        </Button>
                                    </Link>
                                </td>
                                <td className="tc">
                                <Button style={{maxWidth:"150px", minWidth:"150px", minHeight:"50px"}} onClick={()=> (
                                    this.setState({ showContact: !this.state.showContact })
                                    )}>Kontakt</Button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <Message>
						<ContactMessage />
						</Message>
                    </div>
                        {/*<div className="ui container mw9 ph3 center pt4">
                            <section className="billing-tab">
                            <div className="tc">
                            <img alt={"Firmenlogo"} width={235} className="tc pt2 pb4" src={shop.config.logo}/>
                            </div>
                            <h1 className="tc ttu b pb2">{translate( "Vorläufige Restantenbestätigung" )}</h1>
                            {shop.session.contact &&
                                <h2 className="intro-line">
                                {
                                     <span>{translate( "confirmation.thanks_order_anonymous" )}</span>}
                                </h2>}
                            
                            { <p>Ihre Restanten ist bei uns eingegangen und wird schnellstmöglich bearbeitet.</p>
                            }
                            </section>
                            
                            <section className="billing-tab pt4 pb2">
                            <h4 className="tc">{translate( "your data" )}</h4>
                            <table className="billing-overview-table">
                                
                                <colgroup>
                                <col width="25%"/>
                                <col width="75%"/>
                                </colgroup>
                                
                                <tbody>
                                {shop.config.checkoutFeatures.orderNumber && <tr>
                                <td>{translate( "Order Id" )}</td>
                                <td className="overview-value">{order.handid}</td>
                                </tr>
                                }
                                        
                                {order.extras.manual_order_id &&
                                <tr>
                                    <td>{translate( "manual_order_id" )}</td>
                                    <td className="overview-value">{order.extras.referenceId}</td>
                                </tr>
                                }
                                {order.extras.referenceId &&
                                <tr>
                                    <td>{translate( "Referenznummer" )}</td>
                                    <td className="overview-value">{order.extras.manual_order_id}</td>
                                </tr>
                                }
                                
                                {shop.config.checkoutFeatures.orderDate &&
                                <tr>
                                    <td>{translate( "Bestellzeitpunkt" )}</td>
                                    <td className="overview-value">{moment( order.created ).format( "HH:mm [Uhr], DD.MMM YYYY" )}</td>
                                </tr>
                                }
                                
                                
                                <tr className="bb b--black-10">
                                <td className="tl">{translate( "Kundennummer:" )}</td>
                                <td className="overview-value tr">{order.customerid}</td>
                                </tr>
                                <tr className="bb b--black-10">
                                <td>{translate( "Ansprechpartner:" )}</td>
                                <td className="overview-value tr">{order.extras.contact || "-"}</td>
                                </tr>
                                <tr className="bb b--black-10">
                                <td>{translate( "E-Mail:" )}</td>
                                <td className="overview-value tr">{order.extras.email || order.customer.email || "-"}</td>
                                </tr>
                                
                                <tr className="bb b--black-10">
                                <td>{translate( "Telefon:" )}</td>
                                <td className="overview-value tr">{order.extras.phone || order.customer.email ||  "-"}</td>
                                </tr>
                                
                                </tbody>
                            </table>
                            </section>
                            
                            <section className="billing-tab pt1 ">
                            <tr>
                                <table>
                                <colgroup>
                                    <col width="25%"/>
                                    <col width="75%"/>
                                </colgroup>
                                <tbody>
                                    <tr>
                                    <td className="tl fw7">{translate( "Marktadresse:" )}<br/><br/><br/></td>
                                    <td className="tr">
                                        {order.bill.name1} {order.bill.name2} {order.bill.name3} <br/>
                                        {order.bill.street} <br/>
                                        {order.bill.pcode} {order.bill.city} <br/>
                                        {order.bill.country}
                                    </td>
                                    </tr>
                                </tbody>
                                </table>
                                
                            </tr>
                            </section>
                            
                            <section className="billing-tab pt4">
                            <h2 className="tc">{<span>{translate( "Ihre Restanten" )}</span>}</h2>
                            
                            <SuccessTable showTax={order.extras.payment} positions={order.positions} byId={byId} netto={order.netto} currency={order.currency}/>
                            
                            
                            {order.customer.extras.zahlung && <div>
                                <h3 className="mt4">{translate( "Zahlungsweise" )}</h3>
                                <p>{order.customer.extras.zahlung}</p>
                            </div>}
                            {order.deliverdate && <div>
                                <h3 className="mt4">{translate( "Liefertermin (Wunsch)" )}</h3>
                                <p>{moment( moment( order.deliverdate ), "DD.MM.YYYY" ).format( "dddd, DD. MMMM YYYY" )}</p>
                            </div>}
                            
                            
                            {order.extras.attachments && <div>
                                <h3 className="mt4">Ihr Anhang</h3>
                                <p>{order.extras.attachments}</p>
                            </div>}
                            
                            {order.extras.print_receipt && <div>
                                <h3 className="mt4">{translate( "Belegausdruck/Innendienst" )}</h3>
                                <p>{order.extras.print_receipt}</p>
                            </div>}
                            </section>
                            
                            {shop.config.checkout_thank_you && <div className="pv4">
                            <div style={{ whiteSpace: "pre-line" }}>{window.translate( "checkout_thank_you" )}</div>
                            </div>}
                            <div className="tc pt4 pb4">
                            <Link to={{
                                        pathname: `/logout`,
                                        search  : this.props.location.search
                                    }}>
                                        <Button style={{maxWidth:"250px"}}
                                        >
                                        {translate( "Zurück zur Anmeldung" )}
                                        <i className="icon-angle-right"/>
                                        </Button>
                                    </Link>
                            </div>
                        </div>*/}
                    </Responsive>
                </Fragment>
            )
        }

        return (
            <Fragment>
                <section className="container pt2">
                    <ReturnPageProgress progress={0} />
                </section>
                <Responsive minWidth={790} >
                <section className="container tc pb2 pt2">
                <a className={"logo"} >
									<img
										src={shop.config.logo}
										alt="" />
								</a>
					</section>
                <section className="container pb4" style={{width:"45%"}}>
                    {!seasonActive &&                 <Message  >
                                <div>{translate( "Sie befinden sich außerhalb der Restantensaison, eine Restanteneingabe ist daher nicht möglich.")}</div>
                            </Message>}
                            <Message>
						<ContactMessage />
						</Message>
                    {<img className="pb2 w-100" src={"/Weihnachten-Header.jpg"}  centered/>}
                    <div>
                        
					<Table className="pl4 pr3">
					<colgroup>
					</colgroup>
					<thead>
					</thead>
					<tbody>
                        <tr>
                        <h1 style={{color:"#917236"}}  className="pt4 tl"><b>{translate("Restantenerfassung Online ")}</b></h1><br/>
                            <p className=""><b>Herzlich willkommen im Restanten Erfassungs Portal der Chocoladefabriken Lindt & Sprüngli GmbH.</b></p>
                            <p className="pb2">Sie sind angemeldet als: </p>
                        </tr>
                        <tr>
                            <td>
                                <Table className="TableCustData">
                                    <colgroup>
                                        <col width="50%" />
                                        <col width="25%" />
                                    </colgroup>
                                    <thead>
                                        <tr>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td style={{fontSize:15}}><b>Kundennummer:</b>
                                            </td> 
                                            <td>{shop.session.value.map_id}
                                            </td> 
                                        </tr>
                                        <tr>
                                            <td style={{fontSize:15, alignContent:"top"}}><b >Filiale:</b><br/><br/><br/>
                                            </td> 
                                            <td><strong>{shop.session.value.title}</strong><br/>
                                                {shop.session.value.street}<br/>
                                                {shop.session.value.pcode + " " + shop.session.value.city}<br/>
                                                {shop.session.value.country}
                                            </td> 
                                        </tr>
                                        {shop.session && shop.session.value && shop.session.value.extras && !shop.session.value.extras.rewe_extra &&<tr>
                                            <td style={{fontSize:15, alignContent:"top"}}><b >Ihre persönliche Zählunterstützung:</b>
                                            </td>
                                            <td>
                                                <div className="" >
                                                    {shop.session && shop.session.value && shop.session.value.extras && 
                                                    <Button primary onClick={() => {window.open(`${shop.session && shop.session.value && shop.session.value.extras && shop.session.value.extras.rewe_extra && shop.session.value.extras.rewe_extra == "Ja" ? "/Restantenschein Weihnachten 2025 - digital.pdf"
                                                    : shop.session && shop.session.value && shop.session.value.extras && shop.session.value.extras.edeka_extra && shop.session.value.extras.edeka_extra == "Ja" ? "/EDEKA Restantenschein Weihnachten 2025 - digital.pdf" :  "/Restantenschein Weihnachten 2025 - digital.pdf"}`, "_blank")}}>{translate( "PDF herunterladen" )}</Button>}
                                                </div>
                                            </td>
                                        </tr>}
                                    </tbody>
                                </Table>
                                </td>
                        </tr>
                        <tr>
                            <br/>
                        </tr>
                        <tr>
                            <td>
                            <Link to={{
                                pathname: `/logout`,
                                search  : this.props.location.search
                            }}>
                                <Button
                                >
                                {translate( "Zurück zur Anmeldung" )}
                                <i className="icon-angle-right"/>
                                </Button>
                            </Link>
                            </td>
                            <td>
                            {seasonActive && <Link onClick={ (event) => buttonDisabled && event.preventDefault() } to={{
                                pathname: `/return/quantity`,
                                search  : this.props.location.search
                            }}>
                                <Button disabled={buttonDisabled} style={{width:"200px"}}
                                primary >
                                {translate( "Zur Restanteneingabe" )}
                                <i className="icon-angle-right"/>
                                </Button>
                            </Link>}
                            </td>
                        </tr>
                    </tbody>
                    </Table>
                    </div>
                </section>
                </Responsive>
                <Responsive maxWidth={789} >
                <section className="container tc pb2 pt2">
                <a className={"logo"} >
									<img
										src={shop.config.logo}
										alt="" />
								</a>
					</section>
                <div className="pa3">
                {!seasonActive &&                 <Message  >
                                <div>{translate( "Sie befinden sich außerhalb der Restantensaison, eine Restanteneingabe ist daher nicht möglich.")}</div>
                            </Message>}
                            <Message>
						<ContactMessage />
						</Message>
                    <table className="pl3 pr3" >
                        <colgroup>
                        <col width="100%" />
                        </colgroup>
                        <tbody>
                            <tr className="tc bb b--black-20 bt">
                                <td>
                                    <h1 style={{color:"#917236"}}  className="pt4 tc"><b>{translate("Restantenerfassung Online ")}</b></h1><br/>
                                    <p className="tc"><b>Herzlich willkommen im Restanten Erfassungs Portal der Chocoladefabriken Lindt & Sprüngli GmbH.</b></p>
                                    <p className="tc pb2">Sie sind angemeldet als: </p>

                                </td>
                            </tr>
                            <tr className="pa2 bb b--black-20">
                                
                                <td>
                                    <table>
                                    <colgroup>
                                        <col width="25%" />
                                        <col width="75%" />
                                    </colgroup>
                                    <tbody>
                                        <tr className="bb b--black-10">
                                            <td style={{fontSize:15}}><b>Kundennummer:</b>
                                            </td> 
                                            <td>{shop.session.value.map_id}
                                            </td> 
                                        </tr>
                                        <tr>
                                            <td style={{fontSize:15, alignContent:"top"}}><b >Filiale:</b><br/><br/><br/>
                                            </td> 
                                            <td><strong>{shop.session.value.title}</strong><br/>
                                                {shop.session.value.street}<br/>
                                                {shop.session.value.pcode + " " + shop.session.value.city}<br/>
                                                {shop.session.value.country}
                                            </td> 
                                        </tr>
                                        {shop.session && shop.session.value && shop.session.value.extras && !shop.session.value.extras.rewe_extra &&<tr>
                                            <td style={{fontSize:15, alignContent:"top"}}><b >Ihre persönliche Zählunterstützung:</b>
                                            </td>
                                            <td>
                                                <div className="" >
                                                    {shop.session && shop.session.value && shop.session.value.extras && 
                                                    <Button primary onClick={() => {window.open(`${shop.session && shop.session.value && shop.session.value.extras && shop.session.value.extras.rewe_extra && shop.session.value.extras.rewe_extra == "Ja" ? "/Restantenschein Weihnachten 2025 - digital.pdf"
                                                    : shop.session && shop.session.value && shop.session.value.extras && shop.session.value.extras.edeka_extra && shop.session.value.extras.edeka_extra == "Ja" ? "/EDEKA Restantenschein Weihnachten 2025 - digital.pdf" :  "/Restantenschein Weihnachten 2025 - digital.pdf"}`, "_blank")}}>{translate( "PDF herunterladen" )}</Button>}
                                                </div>
                                            </td>
                                        </tr>}
                                    </tbody>
                                    </table>
                                    
                                </td>
                                <td>&nbsp;</td>
                            </tr>
                            <tr>
                            <td>
                                <div className="pb2 tc">
                                </div>
                            </td>
                        </tr>
                        </tbody>

                    </table>
                    <table>
                        <colgroup>
                            <col width="50%" />
                            <col width="50%" />
                        </colgroup>
                        <tbody>
                            <tr className="tc">
                                <td className="tc">
                                    <Link to={{
                                        pathname: `/logout`,
                                        search  : this.props.location.search
                                    }}>
                                        <Button style={{maxWidth:"160px"}}
                                        >
                                        {translate( "Zurück zur Anmeldung" )}
                                        <i className="icon-angle-right"/>
                                        </Button>
                                    </Link>
                                </td>
                                <td onClick={ (event) => buttonDisabled && event.preventDefault() } className="tc">
                                    {seasonActive && <Link to={{
                                        pathname: `/return/quantity`,
                                        search  : this.props.location.search
                                    }}>
                                        <Button disabled={buttonDisabled} style={{maxWidth:"160px"}}
                                        primary >
                                        {translate( "Zur Restanteneingabe" )}
                                        <i className="icon-angle-right"/>
                                        </Button>
                                    </Link>}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    </div>
                </Responsive>
                <LocalFooter/>
            </Fragment>
        );
    }
}

export default ReturnPage;


// WEBPACK FOOTER //
// ./src/theme/lindt/pages/returnCheckout/ReturnPage.js